import type { JSONContent } from '@tiptap/core';
import type { Note } from '@/features/notes/types';
import type { ProjectScope } from '@/features/sync/project-scope';

import type { Unsubscribe } from './subscription';

export type NoteEditorSnapshotSource = 'manual' | 'pre-restore' | 'report-generation';

export interface NoteEditorSnapshot {
  id: string;
  noteId: string;
  title: string;
  content: JSONContent;
  createdAt: unknown;
  createdBy?: string;
  preview: string;
  source: NoteEditorSnapshotSource;
}

export interface CreateNoteEditorSnapshotInput {
  scope: ProjectScope;
  noteId: string;
  title: string;
  content: NoteEditorSnapshot['content'];
  createdBy?: string;
  source: NoteEditorSnapshotSource;
}

export interface RawNotesClient {
  listNotes(scope: ProjectScope): Promise<Note[]>;
  subscribeNotes(scope: ProjectScope, listener: (notes: Note[]) => void): Unsubscribe;
  createEditorSnapshot(input: CreateNoteEditorSnapshotInput): Promise<string>;
  listEditorSnapshots(scope: ProjectScope, noteId: string): Promise<NoteEditorSnapshot[]>;
  loadEditorSnapshot(
    scope: ProjectScope,
    noteId: string,
    snapshotId: string,
  ): Promise<NoteEditorSnapshot | null>;
}

function collectSnapshotText(node: JSONContent | undefined): string {
  if (!node) {
    return '';
  }
  if (node.type === 'text') {
    return node.text ?? '';
  }
  return (node.content ?? []).map(collectSnapshotText).join(' ');
}

export function serializeSnapshotPreview(content: JSONContent): string {
  return collectSnapshotText(content).replace(/\s+/g, ' ').trim().slice(0, 180);
}
